import { render, staticRenderFns } from "./tableCell.vue?vue&type=template&id=a843239e&scoped=true"
import script from "./tableCell.vue?vue&type=script&lang=js"
export * from "./tableCell.vue?vue&type=script&lang=js"
import style0 from "./tableCell.vue?vue&type=style&index=0&id=a843239e&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a843239e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a843239e')) {
      api.createRecord('a843239e', component.options)
    } else {
      api.reload('a843239e', component.options)
    }
    module.hot.accept("./tableCell.vue?vue&type=template&id=a843239e&scoped=true", function () {
      api.rerender('a843239e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/tableCell.vue"
export default component.exports